import React from 'react'

interface Props {
  url: string
  youtubeId: string
  title?: string
}

const YoutubeVideoContainerPlay: React.FC<Props> = ({ url, youtubeId, title }) => {
  return (
    <a className='youtube-video-container-play' href={url}>
      <i className='fal fa-play-circle'>
        <span className='screen-reader-text'>Go to video</span>
      </i>
      <img src={`https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`} alt={title || ''} />
    </a>
  )
}

export default YoutubeVideoContainerPlay
